<template>
  <section class="company-ci-cd-settings-form mt-3">
    <project-ci-cd-settings-form-table
      :alias="alias"
      :form-name="COMPANY_SETTING_CI_CD_FORM"
      :key="ciCdVariablesTableComponentKey"
      :existing-variables="existingVariables"
      @submit="submitForm"
    />
  </section>
</template>


<script>
import CompanyService from '@shared/modules/company/company.service';
import ProjectCiCdSettingsFormTable from '@shared/modules/project-settings/components/project-ci-cd-settings-form-table.vue';
import { FORM_NAME_ENUMS } from '@/shared-modules/variables/form-name.enums';

export default {
  name: 'CompanyVariableTable',
  components: { ProjectCiCdSettingsFormTable },
  data() {
    return {
      ciCdVariablesTableComponentKey: 0
    };
  },
  props: {
    alias: {
      type: String,
      default: null
    },
    ownerType: {
      type: String,
      default: null
    },
    ownerId: {
      type: [Number, String],
      default: null
    }
  },
  computed: {
    COMPANY_SETTING_CI_CD_FORM() {
      return FORM_NAME_ENUMS.COMPANY_SETTING_CI_CD_FORM;
    },
    existingVariables() {
      return this.$store.getters.getExistingCiCdVariables(this.COMPANY_SETTING_CI_CD_FORM);
    }
  },
  beforeMount() {
    this.getExistingCiCdVariables();
  },
  methods: {
    getExistingCiCdVariables() {
      CompanyService.getExistingCiCdVariables(this.alias);
    },
    submitForm(data) {
      data = {
        ...data,
        ownerType: this.ownerType,
        ownerId: parseInt(this.ownerId)
      };

      if (
        Object.values(data)
          .slice(0, 3)
          .every((arr) => Array.isArray(arr) && arr.length === 0)
      ) {
        smallNotification('danger', { title: this.$i18n.t('message.incorrectInput') });
        return;
      } else {
        CompanyService.editCiCdVariables(this.alias, data).then(() => {
          this.ciCdVariablesTableComponentKey += 1;
        });
      }
    }
  }
};
</script>